import script from "./addressManage.vue?vue&type=script&setup=true&lang=js"
export * from "./addressManage.vue?vue&type=script&setup=true&lang=js"

import "./addressManage.vue?vue&type=style&index=0&id=54028bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54028bf4"]])

export default __exports__